import { useData } from '@hooks/useData';
import http from '@core/fetch';
import apiConfig from '@apiConfig';
import { components } from '@apiSchema';
import { SavedSelection } from '@pages/Home/context/TerritorySelectionContext';

export type LandscapeCuisine = components['schemas']['CuisineItem'];
export type LandscapeSegment = components['schemas']['SegmentItem'];
export type OnSiteSegmentGroup = components['schemas']['OnSiteSegmentGroup'];
type RestaurantLandscapeResponse = components['schemas']['RestaurantLandscapeResponse'];

export interface RestaurantLandscapeData {
    cuisines: LandscapeCuisine[];
    segments: LandscapeSegment[];
    onSiteSegments: OnSiteSegmentGroup[];
}

const REQUEST_TYPE: keyof typeof apiConfig = 'get restaurant landscape data';

const DEFAULT_DATA: RestaurantLandscapeData = {
    cuisines: [],
    segments: [],
    onSiteSegments: [],
};

interface TerritoryParams {
    states?: string[];
    metros?: number[];
}

function buildTerritoryParams(savedSelection: SavedSelection | null): TerritoryParams {
    if (!savedSelection || savedSelection.ids.length === 0) return {};
    return savedSelection.mode === 'state'
        ? { states: savedSelection.ids }
        : { metros: savedSelection.ids.map(Number) };
}

async function getRestaurantLandscapeData(
    savedSelection: SavedSelection | null,
): Promise<RestaurantLandscapeData> {
    const response = await http.get(
        REQUEST_TYPE,
        buildTerritoryParams(savedSelection),
    ) as RestaurantLandscapeResponse;
    return {
        cuisines: response?.cuisines ?? [],
        segments: response?.segments ?? [],
        onSiteSegments: response?.onSiteSegments ?? [],
    };
}

export function useLandscapeRestaurantData(savedSelection: SavedSelection | null) {
    return useData(DEFAULT_DATA, getRestaurantLandscapeData, savedSelection);
}
